import NewContactForm from '../../components/NewContactForm/NewContactForm'

const NewContact = () => {
  return <NewContactForm />
}

export default NewContact
